import { render, staticRenderFns } from "./WxOpenTag.vue?vue&type=template&id=19060509&scoped=true&"
import script from "./WxOpenTag.vue?vue&type=script&lang=js&"
export * from "./WxOpenTag.vue?vue&type=script&lang=js&"
import style0 from "./WxOpenTag.vue?vue&type=style&index=0&id=19060509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19060509",
  null
  
)

export default component.exports